<!--
	作者：1764635606@qq.com
	时间：2018-05-31
	描述：模态组件，主要是样式封装，封装了关闭按钮

	props：
	    zIndex:         设置modal层级 iview的message层级为999
		ModalStyle: 	用于修改模态外层样式
		showHeader: 	是否展示头部
		showContent: 	是否展示内容块
		showFooter: 	是否展示底部
		maskClosable:   是否允许点击遮罩层关闭
		closable：            是否显示右上角的关闭按钮
        transfer:       是否将组件放到body下

	slot:
		modal-header:	模态头部
		modal-content:	模态内容块
		modal-footer: 	模态底部

	emit:
		close: 			点击关闭按钮触发close事件
-->

<template>
    <div class="BPModal" ref="bpmodal" :style="{'z-index': zIndex}" v-bp-transfer-dom :data-transfer="transfer">
        <div class="mask" @click="maskClick"></div>
        <div class="modal" ref="modal" :style="ModalStyle">
            <div class="modal-header" v-if="showHeader">
                <slot name="modal-header"></slot>
                <Icon type="md-close" class="icon-close" v-if="closable" @click.native="$emit('close')"></Icon>
            </div>
            <div class="modal-content" v-if="showContent">
                <slot name="modal-content"></slot>
            </div>
            <div class="modal-footer" v-if="showFooter">
                <slot name="modal-footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        props: {
            ModalStyle: {},
            zIndex: {
                type: Number,
                default: 990
            },
            maskClosable: {
                type: Boolean,
                default: true
            },
            closable: {
                type: Boolean,
                default: true
            },
            transfer: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                random: 0
            }
        },
        computed: {
            showHeader () {
                return this.$slots['modal-header']
            },
            showContent () {
                return this.$slots['modal-content']
            },
            showFooter () {
                return this.$slots['modal-footer']
            }
        },
        methods: {
            maskClick () {
                if (this.maskClosable) {
                    this.$emit('close')
                }
            }
        }
    }
</script>

<style lang="less" >
    @form-font-size: 13px;
    @form-font-color: #999999;
    @title-font-size: 16px;
    @title-font-color: #333333;
    @keyframes ani {
        from {top: 20%;}
        to {top: 50%;}
    }
    .BPModal{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 990;
        .mask{
            height: 100%;
            width: 100%;
            background: rgba(0, 0, 0, 0.7);
            /*z-index: 998;*/
        }
        .modal{
            width: 500px;
            background: white;
            /*z-index: 999;*/
            position: absolute;
            max-height: 97%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            animation: ani 0.5s ease-out;
            overflow: auto;
            .modal-header{
                position: relative;;
                text-align: center;
                font-size: @title-font-size;
                font-weight: bold;
                line-height: 50px;
                height: 50px;
                overflow: hidden;
                background: #F7F7F7;
                color: @title-font-color;
                .icon-close{
                    color: #ccc;
                    position: absolute;
                    top: 50%;
                    right: 20px;
                    transform: translateY(-50%);
                    font-size: 16px;
                    padding: 6px;
                    &:hover{
                        background: #ddd;
                    }
                }
            }
            .modal-content{
                textarea{
                    resize: none;
                }
                // min-height: 200px;
                padding: 30px 40px;
                padding-top: 25px;
                /*position: relative;*/
                .line{
                    margin-bottom: 6px;
                }
                .label{
                    line-height: 30px;
                    color: @form-font-color;
                    font-size: @form-font-size;
                }
            }
            .modal-footer{
                text-align: right;
                padding: 20px 40px;
                border-top: 1px solid #ddd;
                .ivu-btn-large{
                    margin-top: 0;
                }
            }
        }
        .table-fixed{
            width: 100%;
            display: table;
            table-layout: fixed;
            .table-cell{
                display: table-cell;
            }
        }
        .ivu-btn-large{
            padding-top: 10px;
            padding-bottom: 10px;
            margin-top: 14px;
        }
    }
</style>
